// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44a0ade9","732":"1dbdf04c","977":"1b2a5b5a"}[chunkId] + ".chunk.js";
};